import router from './router/index' // 路由
import store from './store/index.js'
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

router.beforeEach((to, from, next) => {
  //根据字段判断是否路由过滤
  if (to.matched.some(record => record.meta.auth)) {
    if (store.state.user.loginStatus) {
      // 如果用户登录-继续
      next();
    } else {
      // 如果用户未登录--跳转登录页面
      // 弹出login登录框
      store.dispatch('LOGINSHOW', true);
      router.push({
        name: from.path
      })
    }
  } else {
    next() //若点击的是不需要验证的页面,则进行正常的路由跳转
  }
});



// WEBPACK FOOTER //
// ./src/permissions.js